<template xmlns="http://www.w3.org/1999/html">
  <div class="card">
    <TreeTable :value="rows"
               :loading="loading"
               v-model:editingRows="editingRows"
               v-model:expandedKeys="expandedKeys">
      <template v-if="actions && Object.keys(actions).length > 0">
        <Column :exportable="false">
          <template #body="slotProps">
            <template v-for="(action, key) in actions">
              <template
                v-if="(key !== 'elimina' && key !== 'modificariga' && key !== 'aggiungiriga' && key !== 'aggiorna' && key !== 'annulla') && action.form_modale !== true &&  (!action.condizione || (action.condizione === true && slotProps.node[action.condizione_key] === action.condizione_value))">
                <a :href="generateUrl(action, slotProps.node)"
                   class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                  <i :class="'pi '+action.icona"></i>
                </a>
              </template>
              <template
                v-if="action.form_modale === true && (!action.condizione || (action.condizione === true && slotProps.node[action.condizione_key] === action.condizione_value))">
                <a @click="openModal(action, slotProps.node)"
                   class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                  <i :class="'pi '+action.icona"></i>
                </a>
              </template>
              <template v-if="key === 'aggiungiriga' && !editingRows.includes(slotProps.node)">
                <a @click="aggiungiRiga(slotProps.node)"
                   class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                  <i :class="'pi '+action.icona"></i>
                </a>
              </template>
              <template v-if="key === 'modificariga' && !editingRows.includes(slotProps.node) &&  (!action.condizione || (action.condizione === true && slotProps.node[action.condizione_key] === action.condizione_value))">
                <a @click="modificariga(slotProps.node)"
                   class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                  <i :class="'pi '+action.icona"></i>
                </a>
              </template>
              <template v-if="editingRows.includes(slotProps.node)">
                <template v-if="key === 'aggiorna'">
                  <a @click="saveRow(slotProps.node)">
                    <i :class="'pi '+action.icona"></i>
                  </a>
                </template>
                <template v-if="key === 'annulla'">
                  <a @click="cancelRow(slotProps.node)">
                    <i :class="'pi '+action.icona"></i>
                  </a>
                </template>
              </template>
              <template v-else>
              </template>
            </template>
          </template>
        </Column>
      </template>
      <Column v-for="column in columns"
              :key="column.field"
              :field="column.field"
              :header="column.header"
              :expander="column.expander"
              sortable
              :filter="true">
        <template #body="slotProps">
          <div v-if="editingRows.includes(slotProps.node)">
            <InputText
              v-model="slotProps.node.data[column.field]"
              class="w-full"
            />
          </div>
          <div v-else>
            {{ slotProps.node.data[column.field] }}
          </div>

        </template>
      </Column>
    </TreeTable>

    <Dialog v-model:visible="visible" modal :header="modalForm.title" :style="{  }">
      <div v-if="modalForm.testo" class="mb-4">
        <p>{{ modalForm.testo }}</p>
      </div>
      <FormInput
        :key="modalFormKey"
        :dati="modalForm.dati"
        :formlabel="modalForm.struttura"
        :idform="modalForm.idform"
        stilestruttura=""
        recaptcha=""
        :action=modalForm.action
        ref="modalinput">
      </FormInput>
      <div class="flex justify-end gap-2 mt-4">
        <Button type="button" :label="modalForm.testoannulla" severity="secondary" @click="closeModal"></Button>
        <Button type="button" :label="modalForm.testoconferma" @click="$refs.modalinput.checkForm(0)"></Button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import TreeTable from 'primevue/treetable';
import Column from 'primevue/column';
import axios from 'axios';
import FormInput from "./FormInput.vue";
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Select from "primevue/select";
import InputText from 'primevue/inputtext';


export default {
  name: 'TreeTableAdvance',
  props: [
    'route_righe',
    'route_params',
    'colonne',
    'azioni',
    'is_edit',
  ],
  components: {FormInput, TreeTable, Column, Dialog, Button, Select, InputText},
  data() {
    return {
      rows: [],
      visible: false,
      actions: this.azioni,
      columns: this.colonne,
      loading: false,
      globalfilters: [],
      expandedKeys: {},
      modalForm: {
        title: '',
        struttura: null,
        idform: '',
        dati: {},
        testoannulla: 'Annulla',
        testoconferma: 'Conferma'
      },
      editingRows: [],
      currentAction: null,
      currentNode: null,
      modalFormKey: 0,
      is_edit: this.is_edit,
      newRows: [],
    }
  },
  async mounted() {
    await this.loadData();
  },
  computed: {
    hasNewRowsInEditing() {
      return this.newRows.some(row => this.editingRows.includes(row));
    }
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const response = await axios.get(route(this.route_righe, this.route_params));
        if (response.status === 200) {
          this.rows = this.transformDataForTreeTable(response.data);
          this.initFilters();
        } else {
          this.rows = [];
        }
      } catch (error) {
        console.error('Errore nel caricamento dei dati:', error);
        this.rows = [];
      } finally {
        this.loading = false;
      }
    },
    updateNodeInTree(nodes, updatedNode) {
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].key === updatedNode.key) {

          nodes[i] = updatedNode;
          return true;
        }
        if (nodes[i].children && nodes[i].children.length) {
          const found = this.updateNodeInTree(nodes[i].children, updatedNode);
          if (found) return true;
        }
      }
      return false;
    },
    async openModal(action, node) {
      this.currentAction = action;
      this.currentNode = node;
      this.visible = true;
      try {
        if (action.form_route) {
          const params = action.form_params.reduce((acc, param) => {
            acc[param] = node.data[param];
            return acc;
          }, {});

          const formUrl = route(action.form_route, params);
          const response = await axios.get(formUrl);

          if (response.status === 200) {
            this.modalForm = response.data;
            this.modalFormKey++;
          }
        } else if (action.form) {
          this.modalForm = action.form;
        }
      } catch (error) {
        console.error('Errore nel caricamento del form:', error);
        this.closeModal();
      }
    },
    closeModal() {
      this.visible = false;
      this.modalForm = {
        title: '',
        struttura: null,
        idform: '',
        dati: {},
        testoannulla: 'Annulla',
        testoconferma: 'Conferma'
      };
      this.currentAction = null;
      this.currentNode = null;
    },
    aggiungiRiga(node) {
      const nuovaRiga = {
        key: node.key + 'temp',
        data: {},
        isNew: true
      };

      this.columns.forEach((col) => {
        if (typeof col.ref !== 'undefined') {
          nuovaRiga.data[col.field] = node.data[col.ref];
        } else {
          nuovaRiga.data[col.field] = '';
        }
      });

      if (!node.children) {
        node.children = [];
      }

      node.children.unshift(nuovaRiga);
      this.editingRows.push(nuovaRiga);
      this.newRows.push(nuovaRiga);
      this.expandedKeys[node.key] = true;
    },
    async modificariga(node) {
      if (!node.originalData) {
        node.originalData = { ...node.data };
      }
      if (!this.editingRows.includes(node)) {
        this.editingRows.push(node);
      }

    },
    async saveRow(node) {
      try {
        await axios.post(route(this.azioni['aggiorna'].url), node);

        const index = this.editingRows.indexOf(node);
        if (index !== -1) {
          this.editingRows.splice(index, 1);
        }

        const newRowIndex = this.newRows.indexOf(node);
        if (newRowIndex !== -1) {
          this.newRows.splice(newRowIndex, 1);
          node.isNew = false;
        }

        if (node.originalData) {
          delete node.originalData;
        }

        await this.loadData();

        this.$toast.add({severity: 'success', summary: 'Salvato', detail: 'Riga salvata con successo', life: 3000});

      } catch (error) {
        console.error('Errore nel salvataggio:', error);
        this.$toast.add({severity: 'error', summary: 'Errore', detail: 'Salvataggio fallito', life: 3000});
      }
    },
    async cancelRow(node) {
      const editIndex = this.editingRows.indexOf(node);
      if (editIndex !== -1) {
        this.editingRows.splice(editIndex, 1);
      }


      if (node.isNew || this.newRows.includes(node)) {
        this.removeNodeFromTree(this.rows, node);

        const newRowIndex = this.newRows.indexOf(node);
        if (newRowIndex !== -1) {
          this.newRows.splice(newRowIndex, 1);
        }
      } else {
        if (node.originalData) {
          node.data = { ...node.originalData };
          delete node.originalData;
        }
      }
    },
    removeNodeFromTree(nodes, nodeToRemove) {
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].key === nodeToRemove.key) {
          nodes.splice(i, 1);
          return true;
        }
        if (nodes[i].children && nodes[i].children.length) {
          const found = this.removeNodeFromTree(nodes[i].children, nodeToRemove);
          if (found) return true;
        }
      }
      return false;
    },
    transformDataForTreeTable(data) {
      if (!Array.isArray(data)) {
        console.error('I dati ricevuti non sono un array:', data);
        return [];
      }

      return data.map((item, index) => {

        const treeItem = {
          key: item.key ?? (item.id ? item.id.toString() : index.toString()),
          data: item,
          id: item.id
        };

        if (item.hasOwnProperty('is_categoriapadre')) {
          treeItem.is_categoriapadre = item.is_categoriapadre;
        }
        if (item.hasOwnProperty('is_tipologiapadre')) {
          treeItem.is_tipologiapadre = item.is_tipologiapadre;
        }
        this.columns.forEach(column => {
          if (column.field && item[column.field] !== undefined) {
            treeItem[column.field] = item[column.field];
          }
        });


        if (item.children && Array.isArray(item.children)) {
          treeItem.children = this.transformChildrenForTreeTable(item.children, treeItem.key);
        }

        return treeItem;
      });
    },
    transformChildrenForTreeTable(children, parentKey) {
      return children.map((child, index) => {
        const childItem = {
          key: child.key ?? `${parentKey}-${index}`,
          data: child
        };

        if (child.hasOwnProperty('is_categoriapadre')) {
          childItem.is_categoriapadre = child.is_categoriapadre;
        }

        if (child.hasOwnProperty('is_tipologiapadre')) {
          childItem.is_tipologiapadre = child.is_tipologiapadre;
        }

        this.columns.forEach(column => {
          if (column.field && child[column.field] !== undefined) {
            childItem[column.field] = child[column.field];
          }
        });
        if (child.children && Array.isArray(child.children)) {
          childItem.children = this.transformChildrenForTreeTable(child.children, childItem.key);
        }

        return childItem;
      });
    },
    initFilters() {
      this.globalfilters = this.columns
        .map(c => c.filtro ? c.name : null)
        .filter(v => v);
    },
    generateUrl(action, rowData) {
      const params = action.parametri.reduce((acc, param) => {
        acc[param] = rowData[param];
        return acc;
      }, {});

      console.log(params);

      return route(action.url, params);
    },
  }
}
</script>
